import { StudyCardComponent } from './study-card.component';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared';
import { SponsorStudyListComponent } from './sponsor-study-list.component';
import { SponsorStudiesStorage } from './sponsor-studies-storage';
import { HeaderTitleModule } from '../header-title/header-title.module';
import { NotificationBarModule } from '../notification-bar';

@NgModule({
    declarations: [
        SponsorStudyListComponent,
        StudyCardComponent,
    ],
    imports: [
        SharedModule,
        ReactiveFormsModule,
        HeaderTitleModule,
        NotificationBarModule
    ],
    exports: [SponsorStudyListComponent],
    providers: [SponsorStudiesStorage]
})
export class SponsorDashboardModule { }